// StatusMixin.ts

import { Component, Mixins } from 'vue-property-decorator';
import { StringsMixin } from '@/mixins';

@Component
export class StatusMixin extends Mixins(StringsMixin) {
    statusText: string = "";
    infoText: string = "";
    errorText: string = "";

    get HasStatus() {
        return this.IsNotEmpty(this.statusText);
    }
    get HasInfo() {
        return this.IsNotEmpty(this.infoText);
    }
    get HasError() {
        return this.IsNotEmpty(this.errorText);
    }
    clearStatus(status: string = undefined) {
        this.statusText = status;
        this.infoText = undefined;
        this.errorText = undefined;
    }
    setStatus(status: string) {
        this.clearStatus();
        this.statusText = status;
    }
    setInfo(info: string) {
        this.clearStatus(info);
        this.infoText = info;
        try {
            this.$emit('info', info);
        } catch (e) {
            console.error("Error while emitting 'info' event:", e);
        }
    }
    setError(error: string) {
        console.error(error);
        this.clearStatus(error);
        this.errorText = error;
        try {
            this.$emit('error', error);
        } catch (e) {
            console.error("Error while emitting 'error' event:", e);
        }
    }}